// extracted by mini-css-extract-plugin
export var createdDate = "_n9-1";
export var divider = "_n9-2";
export var headerDivider = "_n9-3";
export var messagesCard = "_n9-0";
export var messagesContainer = "_n9-6";
export var messagesContainerWrapper = "_n9-4";
export var showLeftPanelButton = "_n9-8";
export var topButtons = "_n9-7";
export var withPadding = "_n9-5";